import React from 'react';
import { connect } from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';

const SimActionsPopUp = (props) => {


  return (
    <div className="sim-actions-popup">
      {props.popUpData.type === 'success' && (<svg width="121" height="120" viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M60.5 105.8c-25.252 0-45.8-20.548-45.8-45.8s20.548-45.8 45.8-45.8 45.8 20.548 45.8 45.8-20.548 45.8-45.8 45.8z" fill="var(--theme-light,#e2cff7)" stroke="var(--theme-primary, #810ea9)" stroke-width="4.4" />
        <path d="M37.5 57.267 55.337 75 83.5 47" stroke="var(--theme-primary, #810ea9)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      )}
      {props.popUpData.type === 'error' && (<svg width="121" height="120" viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M60.5 105.8c-25.252 0-45.8-20.548-45.8-45.8s20.548-45.8 45.8-45.8 45.8 20.548 45.8 45.8-20.548 45.8-45.8 45.8z" fill="var(--theme-light,#e2cff7)" stroke="var(--theme-primary, #810ea9)" stroke-width="4.4" />
        <path d="m58.15 37.828 2.35 31.733 2.35-31.733a2.357 2.357 0 1 0-4.7 0z" stroke="var(--theme-primary, #810ea9)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="60.5" cy="82.5" r="4.5" fill="var(--theme-primary, #810ea9)" />
      </svg>
      )}
      <p className="action-popup-title">{props.popUpData.message}</p>
      <BtnSubmit text="הבנתי, תודה" onclick={() => props.onClose()}></BtnSubmit>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    portalState: state.portalsBlock,
    transferOrgState: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SimActionsPopUp);
